(function () {
  var REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
  var SWIPE_THRESHOLD = 40;
  var VIDEO_START_TIMEOUT_MS = 2500;

  function initHero(root) {
    if (!root || root.dataset.hqHeroInitialized === 'true') return;

    var states = root.querySelector('[data-hq-hero-states]');
    if (!states) return;

    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-hq-hero-slide]')
    );

    var dots = Array.prototype.slice.call(
      root.querySelectorAll('[data-hq-hero-dot]')
    );

    if (slides.length < 2) return;

    root.dataset.hqHeroInitialized = 'true';

    var reducedMotionMedia = window.matchMedia(
      REDUCED_MOTION_QUERY
    );

    var imageDurationMs = parseInt(
      root.dataset.imageDurationMs || '4000',
      10
    );

    var activeIndex = 0;

    var timer = null;
    var videoStartTimer = null;
    var cycleToken = 0;

    var pointerDown = false;
    var pointerStartX = 0;
    var pointerStartY = 0;
    var pointerId = null;

    /*
      Remember which slide the pointer originally went down on.

      This is important because setPointerCapture() can cause
      pointerup / click to target the carousel wrapper instead
      of the card in normal desktop Chrome.
    */
    var pointerStartSlideIndex = null;

    var interactionPaused = false;

    function wrapIndex(index) {
      return (
        (index + slides.length) %
        slides.length
      );
    }

    function activeSlide() {
      return slides[activeIndex];
    }

    function getVideo(slide) {
      if (!slide) return null;

      return slide.querySelector(
        '.hq-hero__state-video'
      );
    }

    function clearTimers() {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }

      if (videoStartTimer) {
        window.clearTimeout(
          videoStartTimer
        );

        videoStartTimer = null;
      }
    }

    function hideVideo(slide) {
      if (!slide) return;

      slide.classList.remove(
        'is-video-playing'
      );
    }

    function resetVideo(video) {
      if (!video) return;

      try {
        video.pause();
      } catch (error) {}

      try {
        video.currentTime = 0;
      } catch (error) {}
    }

    function stopAllVideos(reset) {
      slides.forEach(function (slide) {
        var video = getVideo(slide);

        hideVideo(slide);

        if (!video) return;

        try {
          video.pause();
        } catch (error) {}

        if (reset) {
          try {
            video.currentTime = 0;
          } catch (error) {}
        }
      });
    }

    function canRunAutomatically() {
      return (
        !reducedMotionMedia.matches &&
        !document.hidden &&
        !interactionPaused
      );
    }

    function updateSlides(nextIndex) {
      activeIndex = wrapIndex(
        nextIndex
      );

      var prevIndex = wrapIndex(
        activeIndex - 1
      );

      var nextVisibleIndex = wrapIndex(
        activeIndex + 1
      );

      slides.forEach(
        function (slide, index) {
          var isActive =
            index === activeIndex;

          var isPrev =
            index === prevIndex;

          var isNext =
            index === nextVisibleIndex;

          slide.classList.toggle(
            'is-active',
            isActive
          );

          slide.classList.toggle(
            'is-prev',
            isPrev
          );

          slide.classList.toggle(
            'is-next',
            isNext
          );

          slide.setAttribute(
            'aria-hidden',
            isActive
              ? 'false'
              : 'true'
          );
        }
      );

      dots.forEach(
        function (dot, index) {
          var isActive =
            index === activeIndex;

          dot.classList.toggle(
            'is-active',
            isActive
          );

          dot.setAttribute(
            'aria-current',
            isActive
              ? 'true'
              : 'false'
          );
        }
      );
    }

    function scheduleImageAdvance(
      token
    ) {
      clearTimers();

      if (!canRunAutomatically()) {
        return;
      }

      timer = window.setTimeout(
        function () {
          if (
            token !== cycleToken
          ) {
            return;
          }

          goTo(
            activeIndex + 1,
            false
          );
        },
        imageDurationMs
      );
    }

    function fallbackToImage(
      slide,
      video,
      token
    ) {
      if (
        token !== cycleToken
      ) {
        return;
      }

      if (
        slide !== activeSlide()
      ) {
        return;
      }

      hideVideo(slide);

      resetVideo(video);

      scheduleImageAdvance(
        token
      );
    }

    function startVideoCycle(
      slide,
      video,
      token
    ) {
      clearTimers();

      hideVideo(slide);

      if (!canRunAutomatically()) {
        return;
      }

      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;

      try {
        video.currentTime = 0;
      } catch (error) {}

      var settled = false;

      function cleanupStartListeners() {
        video.removeEventListener(
          'playing',
          onPlaying
        );

        video.removeEventListener(
          'error',
          onFailure
        );

        video.removeEventListener(
          'abort',
          onFailure
        );
      }

      function onPlaying() {
        if (settled) return;

        if (
          token !== cycleToken
        ) {
          return;
        }

        if (
          slide !== activeSlide()
        ) {
          return;
        }

        settled = true;

        cleanupStartListeners();

        if (videoStartTimer) {
          window.clearTimeout(
            videoStartTimer
          );

          videoStartTimer = null;
        }

        slide.classList.add(
          'is-video-playing'
        );
      }

      function onFailure() {
        if (settled) return;

        settled = true;

        cleanupStartListeners();

        if (videoStartTimer) {
          window.clearTimeout(
            videoStartTimer
          );

          videoStartTimer = null;
        }

        fallbackToImage(
          slide,
          video,
          token
        );
      }

      video.addEventListener(
        'playing',
        onPlaying
      );

      video.addEventListener(
        'error',
        onFailure
      );

      video.addEventListener(
        'abort',
        onFailure
      );

      videoStartTimer =
        window.setTimeout(
          function () {
            if (settled) return;

            settled = true;

            cleanupStartListeners();

            videoStartTimer = null;

            fallbackToImage(
              slide,
              video,
              token
            );
          },
          VIDEO_START_TIMEOUT_MS
        );

      var playPromise;

      try {
        playPromise =
          video.play();
      } catch (error) {
        onFailure();
        return;
      }

      if (
        playPromise &&
        typeof playPromise.catch ===
          'function'
      ) {
        playPromise.catch(
          onFailure
        );
      }
    }

    function startActiveCycle() {
      clearTimers();

      var slide =
        activeSlide();

      if (!slide) return;

      var token =
        ++cycleToken;

      var video =
        getVideo(slide);

      if (!canRunAutomatically()) {
        hideVideo(slide);
        return;
      }

      if (video) {
        startVideoCycle(
          slide,
          video,
          token
        );
      } else {
        scheduleImageAdvance(
          token
        );
      }
    }

    function stopCurrentCycle(
      resetCurrentVideo
    ) {
      clearTimers();

      cycleToken += 1;

      var slide =
        activeSlide();

      var video =
        getVideo(slide);

      if (!video) return;

      try {
        video.pause();
      } catch (error) {}

      if (resetCurrentVideo) {
        hideVideo(slide);

        try {
          video.currentTime = 0;
        } catch (error) {}
      }
    }

    function goTo(
      index,
      userInitiated
    ) {
      stopCurrentCycle(true);

      stopAllVideos(true);

      updateSlides(index);

      if (userInitiated) {
        interactionPaused = false;
      }

      startActiveCycle();
    }

    function pauseForInteraction() {
      if (interactionPaused) {
        return;
      }

      interactionPaused = true;

      clearTimers();

      cycleToken += 1;

      var video =
        getVideo(
          activeSlide()
        );

      if (video) {
        try {
          video.pause();
        } catch (error) {}
      }
    }

    function resumeAfterInteraction() {
      if (!interactionPaused) {
        return;
      }

      interactionPaused = false;

      var slide =
        activeSlide();

      var video =
        getVideo(slide);

      if (!canRunAutomatically()) {
        return;
      }

      if (
        video &&
        slide.classList.contains(
          'is-video-playing'
        ) &&
        video.currentTime > 0 &&
        !video.ended
      ) {
        var token =
          ++cycleToken;

        var resumePromise;

        try {
          resumePromise =
            video.play();
        } catch (error) {
          fallbackToImage(
            slide,
            video,
            token
          );

          return;
        }

        if (
          resumePromise &&
          typeof resumePromise.catch ===
            'function'
        ) {
          resumePromise.catch(
            function () {
              fallbackToImage(
                slide,
                video,
                token
              );
            }
          );
        }
      } else {
        startActiveCycle();
      }
    }

    /*
      ========================================================
      VIDEO END / FAILURE
      ========================================================
    */

    slides.forEach(
      function (slide) {
        var video =
          getVideo(slide);

        if (!video) return;

        video.addEventListener(
          'ended',
          function () {
            if (
              slide !==
              activeSlide()
            ) {
              return;
            }

            if (
              !slide.classList.contains(
                'is-video-playing'
              )
            ) {
              return;
            }

            goTo(
              activeIndex + 1,
              false
            );
          }
        );

        video.addEventListener(
          'error',
          function () {
            if (
              slide !==
              activeSlide()
            ) {
              return;
            }

            var token =
              ++cycleToken;

            fallbackToImage(
              slide,
              video,
              token
            );
          }
        );
      }
    );

    /*
      ========================================================
      DOT NAVIGATION
      ========================================================
    */

    dots.forEach(
      function (dot) {
        dot.addEventListener(
          'click',
          function () {
            var index =
              parseInt(
                dot.dataset
                  .slideIndex ||
                  '0',
                10
              );

            goTo(
              index,
              true
            );
          }
        );
      }
    );

    /*
      ========================================================
      POINTER / DRAG / DESKTOP SIDE CARD NAVIGATION
      ========================================================

      Important desktop behavior:

      We record the actual slide under the pointer BEFORE
      pointer capture is enabled.

      Therefore:
      - normal Chrome desktop clicks work
      - DevTools clicks work
      - mouse drag still works
      - touch/swipe still works
      - mobile side-card tap behavior is not added
    */

    states.addEventListener(
      'pointerdown',
      function (event) {
        if (
          event.pointerType ===
            'mouse' &&
          typeof event.button ===
            'number' &&
          event.button !== 0
        ) {
          return;
        }

        if (
          event.target &&
          event.target.closest &&
          event.target.closest(
            '[data-hq-hero-dot]'
          )
        ) {
          return;
        }

        pointerDown = true;

        pointerId =
          event.pointerId;

        pointerStartX =
          event.clientX;

        pointerStartY =
          event.clientY;

        /*
          Capture the original card BEFORE
          setPointerCapture() changes the
          pointerup target.
        */
        pointerStartSlideIndex =
          null;

        if (
          event.target &&
          event.target.closest
        ) {
          var pressedSlide =
            event.target.closest(
              '[data-hq-hero-slide]'
            );

          if (pressedSlide) {
            pointerStartSlideIndex =
              slides.indexOf(
                pressedSlide
              );
          }
        }

        states.classList.add(
          'is-dragging'
        );

        pauseForInteraction();

        if (
          states.setPointerCapture
        ) {
          try {
            states.setPointerCapture(
              event.pointerId
            );
          } catch (error) {}
        }
      }
    );

    states.addEventListener(
      'pointerup',
      function (event) {
        if (!pointerDown) {
          return;
        }

        if (
          pointerId !== null &&
          event.pointerId !==
            pointerId
        ) {
          return;
        }

        pointerDown = false;

        pointerId = null;

        states.classList.remove(
          'is-dragging'
        );

        var deltaX =
          event.clientX -
          pointerStartX;

        var deltaY =
          event.clientY -
          pointerStartY;

        var movedHorizontally =
          Math.abs(deltaX) >
            SWIPE_THRESHOLD &&
          Math.abs(deltaX) >
            Math.abs(deltaY);

        /*
          Genuine swipe / mouse drag.
        */
        if (movedHorizontally) {
          interactionPaused = false;

          if (deltaX < 0) {
            goTo(
              activeIndex + 1,
              true
            );
          } else {
            goTo(
              activeIndex - 1,
              true
            );
          }

          pointerStartSlideIndex =
            null;

          return;
        }

        /*
          DESKTOP CLICK ON A SIDE CARD.

          Do this on pointerup instead of relying
          on the browser-generated click event,
          because pointer capture can redirect
          that click to the carousel wrapper.
        */
        if (
          window.matchMedia(
            '(min-width: 768px)'
          ).matches &&
          pointerStartSlideIndex !==
            null &&
          pointerStartSlideIndex !==
            activeIndex
        ) {
          var pressedSlide =
            slides[
              pointerStartSlideIndex
            ];

          if (
            pressedSlide &&
            (
              pressedSlide.classList.contains(
                'is-prev'
              ) ||
              pressedSlide.classList.contains(
                'is-next'
              )
            )
          ) {
            var targetIndex =
              pointerStartSlideIndex;

            pointerStartSlideIndex =
              null;

            interactionPaused = false;

            goTo(
              targetIndex,
              true
            );

            return;
          }
        }

        pointerStartSlideIndex =
          null;

        /*
          Normal interaction on the active card
          or a mobile tap without a swipe.
        */
        resumeAfterInteraction();
      }
    );

    states.addEventListener(
      'pointercancel',
      function () {
        pointerDown = false;
        pointerId = null;
        pointerStartSlideIndex =
          null;

        states.classList.remove(
          'is-dragging'
        );

        resumeAfterInteraction();
      }
    );

    /*
      ========================================================
      TAB VISIBILITY
      ========================================================
    */

    document.addEventListener(
      'visibilitychange',
      function () {
        if (document.hidden) {
          stopCurrentCycle(false);

          var video =
            getVideo(
              activeSlide()
            );

          if (video) {
            try {
              video.pause();
            } catch (error) {}
          }
        } else if (
          !interactionPaused
        ) {
          stopAllVideos(true);

          startActiveCycle();
        }
      }
    );

    /*
      ========================================================
      REDUCED MOTION
      ========================================================
    */

    function handleReducedMotionChange() {
      stopCurrentCycle(true);

      stopAllVideos(true);

      if (
        !reducedMotionMedia.matches
      ) {
        startActiveCycle();
      }
    }

    if (
      reducedMotionMedia
        .addEventListener
    ) {
      reducedMotionMedia
        .addEventListener(
          'change',
          handleReducedMotionChange
        );
    } else if (
      reducedMotionMedia.addListener
    ) {
      reducedMotionMedia.addListener(
        handleReducedMotionChange
      );
    }

    /*
      ========================================================
      INITIAL STATE
      ========================================================
    */

    updateSlides(0);

    stopAllVideos(true);

    startActiveCycle();
  }

  /*
    ==========================================================
    BOOT
    ==========================================================
  */

  function boot(scope) {
    var roots = [];

    if (
      scope &&
      scope.matches &&
      scope.matches(
        '[data-hq-hero]'
      )
    ) {
      roots.push(scope);
    }

    if (
      scope &&
      scope.querySelectorAll
    ) {
      roots =
        roots.concat(
          Array.prototype.slice.call(
            scope.querySelectorAll(
              '[data-hq-hero]'
            )
          )
        );
    }

    roots.forEach(
      initHero
    );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        boot(document);
      }
    );
  } else {
    boot(document);
  }

  /*
    Shopify Theme Editor support.
  */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      boot(event.target);
    }
  );
})();